import { Alert, Box, Button, Divider, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import UserService from "services/UserService";
import "./UserProfile.scss";

export const UserProfile = () => {
  const [teamName, setTeamName] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [teamNameErrors, setTeamNameErrors] = useState<string[]>([]);
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
  const [showTeamNameSuccess, setShowTeamNameSuccess] = useState<boolean>(false);
  const [showPasswordSuccess, setShowPasswordSuccess] = useState<boolean>(false);

  useEffect(() => {
    setTeamName(UserService.getUserInfo()?.teamName || "");
  }, []);

  const onTeamNameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTeamName(e.target.value);
  };

  const updateTeamName = async () => {
    if (!teamName || !teamName.trim()) {
      setTeamNameErrors(["Team Name is required."]);
      return;
    }
    setTeamNameErrors([]);
    setShowTeamNameSuccess(false);
    const response = await UserService.updateTeamName(teamName);
    if (response && response.errors) {
      setTeamNameErrors(response.errors || ["An unknown error occured. Please try again."]);
    } else {
      setShowTeamNameSuccess(true);
    }
  };

  const changePassword = async () => {
    if (password !== confirmPassword) {
      setPasswordErrors(["Passwords do not match."]);
      return;
    }
    setShowPasswordSuccess(false);
    setPasswordErrors([]);
    const response = await UserService.changePassword(currentPassword, password);
    if (response && response.errors) {
      setPasswordErrors(response.errors || ["An unknown error occured. Please try again."]);
    } else {
      setShowPasswordSuccess(true);
    }
  };

  return (
    <div className="user-profile">
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
      >
        <h3>Account</h3>
        <div className="settings-group">
          <div>
            <TextField required label="Team Name" size="small" className="input--wide" value={teamName} onChange={onTeamNameChanged} />
          </div>
          <div className="errors">
            {teamNameErrors.map((e) => (
              <div key={e} className="error-message">
                {e}
              </div>
            ))}
          </div>
          {showTeamNameSuccess && (
            <Alert className="alert" severity="success" onClose={() => setShowTeamNameSuccess(false)}>
              Team name updated
            </Alert>
          )}
          <Button className="action-button" variant="contained" onClick={updateTeamName}>
            Update
          </Button>
        </div>
        <Divider />
        <h3>Change Password</h3>
        <div className="settings-group">
          <div>
            <TextField required label="Current Password" type="password" size="small" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
          </div>
          <div>
            <TextField required label="New Password" type="password" size="small" value={password} onChange={(e) => setPassword(e.target.value)} />
            <TextField required label="Confirm Password" type="password" size="small" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
          </div>
          <div className="errors">
            {passwordErrors.map((e) => (
              <div key={e} className="error-message">
                {e}
              </div>
            ))}
          </div>
          {showPasswordSuccess && (
            <Alert className="alert" severity="success" onClose={() => setShowPasswordSuccess(false)}>
              Password updated
            </Alert>
          )}
          <Button className="action-button" variant="contained" onClick={changePassword}>
            Change Password
          </Button>
        </div>
        <Divider />
      </Box>
    </div>
  );
};
